console.log('js/cc-validation.js -> v0.1.0');
;var cardFieldName = 'adyen-encrypted-form-number';

function blockNonNumberEvents (e) {
	var key;
	var isCtrl = false;
	var keychar;
	var reg;

	if ( window.event ) {
		key = e.keyCode;
		isCtrl = window.event.ctrlKey
	} else if ( e.which ) {
		key = e.which;
		isCtrl = e.ctrlKey;
	}

	if ( isNaN( key ) )
		return true;

	keychar = String.fromCharCode( key );

	// check for backspace or delete, or if Ctrl was pressed
	if ( key == 8 || isCtrl ) {
		return true;
	}

	reg = /[\d ]/;

	return reg.test( keychar );
}


function trim ( s ) {
    return rtrim( ltrim( s ) );
}

function ltrim ( s ) {
    if ( typeof s !== "string" ) {
        return s;
    }
    var w = " \r\n\t\f";
    // remove all beginning white space
    while ( w.indexOf( s.charAt( 0 ) ) != -1 && s.length != 0 )
        s = s.substring( 1 );
    return s;
}

function rtrim ( s ) {
    if ( typeof s !== "string" ) {
        return s;
    }
    var w = " \r\n\t\f";
    // remove all ending white space
    while ( w.indexOf( s.charAt( s.length - 1 ) ) != -1 && s.length != 0 )
        s = s.substring( 0, s.length - 1 );
    return s;
}

function digitsOnly ( s ) {
    if ( typeof s !== "string" ) {
        return s;
    }

    var w = "0123456789";
    var r = "";
    for ( var i = 0; i < s.length; i++ ) {
        if ( w.indexOf( s.charAt( i ) ) != -1 ) {
            r += s.charAt( i );
        }
    }
    return r;
}

function removeLeadingZeros ( s ) {
    if ( typeof s !== "string" ) {
        return s;
    }
    while ( s.charAt( 0 ) == "0" && s.length != 0 )
        s = s.substring( 1 );
    return s;
}

var card_previousCardNumber ="";
function card_validateCcNumber(e) {
	var cardNumber = document.getElementById( cardFieldName ).value;

	// empty card field - reset all
	if (cardNumber.length == 0) {
		card_previousCardNumber = cardNumber;
		return;
	}

	// When editing the card (but not adding digits at the end), don't display validation error(s) and don't reformat the number
	var l=0;
	while(l < card_previousCardNumber.length && l < cardNumber.length) {
		if(cardNumber[l] != card_previousCardNumber[l]) {
			card_previousCardNumber = cardNumber;
			return;
		}
		l++;
	}

	// remove all whitespace
	cardNumber = cardNumber.replace(/\s+/g, '');

	var nrOfDigits = cardNumber.length;
	if(nrOfDigits > 19){
		card_ccNumberPresentation(false);
		return;
	}

	card_ccNumberPresentation(true);

	//show value with white space after four numbers
	var result = cardNumber.replace(/(\d{4})/g, '$1 ');
	result = result.replace(/\s+$/, ''); //remove trailing spaces

	card_previousCardNumber = result;
	document.getElementById( cardFieldName ).value = result;
}

function card_ccNumberPresentation(valid){
	var errors = [];
	errors.push( cardFieldName );
	if(valid){
		//clearErrors(errors);
	}
	else{
		//markErrorFields(errors);
	}
}

$(function() {
	var cc = $('#'+cardFieldName);
	cc.on('keypress', function(e) { return blockNonNumberEvents(e); });
	cc.on('keyup change', function(e) { return card_validateCcNumber(e); });
})
